import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('로그인 후 조합원 자격 보유여부를 알 수 있어요'))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 조합원 자격 팔기 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 보유주식 팔면 수수료 0원, 100,000P 적립 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 보유 주식 팔기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_button_s = _resolveComponent("ag-button-s")!
  const _component_regist_sell_stake_modal = _resolveComponent("regist-sell-stake-modal")!
  const _component_view_my_stake = _resolveComponent("view-my-stake")!
  const _component_link_account_modal = _resolveComponent("link-account-modal")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    height: "375px",
    "model-value": _ctx.isOpenRef,
    "safe-area": true,
    "swipe-to-close": true,
    "onUpdate:modelValue": _ctx.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, { handle: true }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_header, {
            title: "판매등록",
            onClose: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':`닫기`});_ctx.setOpen()})
          }),
          _createVNode(_component_ag_box_s, { css: {p: '16px 20px', dp: 'block', textAlign: 'center'} }, {
            default: _withCtx(() => [
              (!_ctx.user)
                ? (_openBlock(), _createBlock(_component_ag_text_s, {
                    key: 0,
                    css: {dp: 'block', textAlign: 'center', mb: 8, mt: 24, color: 'gray3'}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ag_text_s, {
                    key: 1,
                    css: {dp: 'block', textAlign: 'center', mb: 8, bt: 24, color: _ctx.isAvaliable ? 'block' : 'gray3'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isAvaliable ? '판매 가능한 참여 조합이 있어요!' : '아직 판매 가능한 참여 조합이 없습니다'), 1)
                    ]),
                    _: 1
                  }, 8, ["css"])),
              _createVNode(_component_ag_button_s, {
                css: {block: 'md', width: '100%', corner: 'full', outline: 'primary', mb: 24},
                disabled: !_ctx.isAvaliable || _ctx.user === null,
                onClickCapture: _cache[1] || (_cache[1] = () => {
            _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합원 자격 팔기', 'clickContent':`조합원 자격 팔기`});
            (_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.checkIsLinked())
          })
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_regist_sell_stake_modal, {
                "open-type": 'create',
                "is-open": _ctx.stakeSellOpen,
                onCloseWithResult: _ctx.branchResult,
                onClose: _cache[2] || (_cache[2] = () => _ctx.stakeSellOpen = false)
              }, null, 8, ["is-open", "onCloseWithResult"]),
              _createVNode(_component_view_my_stake, {
                "open-type": 'result',
                "is-open": _ctx.viewMyStakeOpen,
                onClose: _cache[3] || (_cache[3] = () => _ctx.viewMyStakeOpen = false)
              }, null, 8, ["is-open"]),
              _createVNode(_component_link_account_modal, {
                "model-value": _ctx.linkAccountModal,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => _ctx.linkAccountModal = value),
                onComplete: _cache[5] || (_cache[5] = () => {_ctx.stakeSellOpen = true; _ctx.linkAccountModal=false;})
              }, null, 8, ["model-value"]),
              _createVNode(_component_ag_text_s, { css: {dp: 'block', mb: 8, bt: 24, textAlign: 'center'} }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ag_button_s, {
                css: {block: 'md', width: '100%', corner: 'full'},
                onClickCapture: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'보유 주식 팔기', 'clickContent':`보유 주식 팔기`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.openSellModal())})
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}